export default "__VITE_ASSET__ByV$OU2y__"